import React from 'react'
import Select from 'react-select'

import * as S from './SelectStyle'


interface ISelectOptionsType {
    value: string;
    label: string;
}

export interface iSelect {
    placeholder?: string;
    disabled?: boolean;
    value?: string | any;
    onChangeSelect?: (value: any) => void;
    selectItems?: ISelectOptionsType[];

}

const SelectComponent: React.FC<iSelect> = (props) => {
    const { placeholder, value, selectItems, onChangeSelect, disabled, } = props

    return (
        <S.SelectComponent>
            <Select
                classNamePrefix="select"
                isDisabled={disabled}
                placeholder={placeholder}
                onChange={onChangeSelect}
                options={selectItems}
                value={value}
            />
        </S.SelectComponent>
    )
}

export default SelectComponent